const BASE_URL = import.meta.env.VITE_REACT_APP_API_URL;

export const endpoints = {
  /* GET Requests */
  // User
  isTeacher: `${BASE_URL}/elite/v1/is-teacher`,
  userPurchases: `${BASE_URL}/elite/v3/user-purchases`,
  accountPage: `${BASE_URL}/elite/v2/account-page`,
  getBankCats: `${BASE_URL}/elite/v1/get-bank-cats`,
  wallet: `${BASE_URL}/elite/v1/wallet`,
  checkInfo: `${BASE_URL}/elite/v2/check-info`,
  teacehrDataQuizReport: `${BASE_URL}/elite/v1/teacher-data-for-quiz-report`,
  checkSession: `${BASE_URL}/elite/v1/check-session`,
  checkVersionAndSW: `${BASE_URL}/elite/v1/check-version-and-sw`,
  getMyTeachers: `${BASE_URL}/elite/v1/get-my-teachers`,

  // New User Request
  getUser: `${BASE_URL}/elite/v1/get-user`,
  getPassResetKey: `${BASE_URL}/elite/v1/pass-reset`,
  changePassWithResetKey: `${BASE_URL}/elite/v1/pass-reset-key`,
  quizGrades: `${BASE_URL}/elite/v1/quiz-grades`,
  hwProgress: `${BASE_URL}/elite/v1/get-hw-progress`,
  invoices: `${BASE_URL}/elite/v1/invoices`,

  // Portal
  teacherLessons: `${BASE_URL}/elite/v1/teacher-lessons`,
  getTeacherCats: `${BASE_URL}/elite/v1/get-teacher-cats`,
  // getPortal: `${BASE_URL}/elite/v1/get-portal`,
  teachersInfo: `${BASE_URL}/elite/v1/teachersinfo2`,
  teachersInfo1: `${BASE_URL}/elite/v1/teachersinfo`,
  teacherData: `${BASE_URL}/elite/v3/teacherdata`,
  getTeacherCatLessons: `${BASE_URL}/elite/v1/get-teacher-cats-lessons`,
  sidebarLessons: `${BASE_URL}/elite/v1/sidebarlessons`,
  // New Portal Request
  getPortal: `${BASE_URL}/elite/v1/get-portal`,

  // Single GET Requests
  lesson: `${BASE_URL}/elite/v1/lesson`, // Cached
  lessonV2: `${BASE_URL}/elite/v1/get-lesson`, // Cached
  getLiveSession: `${BASE_URL}/elite/v1/get-live-session`, // Cached
  teacherQuizzes: `${BASE_URL}/elite/v1/teacher-quizzes`, // Cached
  studentsList: `${BASE_URL}/elite/v1/students-list`, // Cached
  teacherSales: `${BASE_URL}/elite/v1/my-sales`, // Cached
  teacherSalesByProduct: `${BASE_URL}/elite/v1/invoices/by-product`, // Cached
  teacherSalesByCategory: `${BASE_URL}/elite/v1/invoices/by-category`, // Cached
  getBankQuestions: `${BASE_URL}/elite/v1/get-bank-questions`, // Cached
  teacherCatsQzsHwsLsns: `${BASE_URL}/elite/v1/teacher-cats-qzs-hws-payments`,
  getStudentData: `${BASE_URL}/elite/v1/student-data`,
  qzHwResultTeacehr: `${BASE_URL}/elite/v1/quiz-hw-result-teacher`,
  invoice: `${BASE_URL}/elite/v2/invoice`,
  getGrade: `${BASE_URL}/elite/v1/grade`,
  checkCoupon: `${BASE_URL}/elite/v1/check-coupon`,
  checkCode: `${BASE_URL}/elite/v1/check-code`,
  updateCode: `${BASE_URL}/elite/v2/update-code`,
  getAttendanceReport: `${BASE_URL}/elite/v1/get-offline-attendance`,
  getQashqoolAppDownloadUrl: `${BASE_URL}/elite/v1/electron-presigned-url`,

  // POST Requests
  updateMissingInfo: `${BASE_URL}/elite/v1/update-missing-info`,
  updateMissingInfo2: `${BASE_URL}/elite/v2/update-missing-info`,
  updateUserInfo: `${BASE_URL}/elite/v1/update-user-info`,
  deleteLesson: `${BASE_URL}/elite/v1/delete-lesson`,
  changePassword: `${BASE_URL}/elite/v1/change-password`,
  aiAssistant: `${BASE_URL}/elite/v1/ai-assistant`,
  vertexAiAssistant: `${BASE_URL}/elite/v1/vertex-ai-assistant`,
  createHomework: `${BASE_URL}/elite/v1/create-homework`,
  createLesson: `${BASE_URL}/elite/v2/create-lesson`,
  createQuiz: `${BASE_URL}/elite/v1/create-quiz`,
  createQuestion: `${BASE_URL}/elite/v1/create-question`,
  editGetLesson: `${BASE_URL}/elite/v1/single-lesson-edit`,
  editLesson: `${BASE_URL}/elite/v1/edit-lesson`,
  getAssessmentDataForEdit: `${BASE_URL}/elite/v1/single-assessment-edit`,
  editQuiz: `${BASE_URL}/elite/v1/edit-quiz`,
  updateProfile: `${BASE_URL}/elite/v1/change-profile-data`,
  deleteBankQuestion: `${BASE_URL}/elite/v1/delete-bank-question`,
  createBankTag: `${BASE_URL}/elite/v1/create-bank-tag`,
  setPortal: `${BASE_URL}/elite/v1/set-portal-teacher`,
  // signIn: `${BASE_URL}/jwt-auth/v1/token`,
  // me: `${BASE_URL}/jwt-auth/v1/token/validate`,
  signIn: `${BASE_URL}/jwt/v1/generate`,
  me: `${BASE_URL}/jwt/v1/me`,
  googleSocialLogin: `${BASE_URL}/elite/v1/google-social-login`,
  facebookSocialLogin: `${BASE_URL}/elite/v1/facebook-social-login`,
  createUser: `${BASE_URL}/elite/v2/create-user`,
  manageTeacherCats: `${BASE_URL}/elite/v1/manage-new-teacher-cats`,
  manageTeacherOfflineGroups: `${BASE_URL}/elite/v1/manage-teacher-offline-groups`,
  changeStudentData: `${BASE_URL}/elite/v1/change-student-data`,
  fawryPurchase: `${BASE_URL}/elite/v1/fawrypurchase`,
  fawaterakPurchase: `${BASE_URL}/elite/v1/fawaterakpurchase`,
  codePurchase: `${BASE_URL}/elite/v2/codepurchase`,
  freePurchase: `${BASE_URL}/elite/v1/freepurchase`,
  openLessonForStudents: `${BASE_URL}/elite/v1/batch-open-lesson`,
  walletPurchase: `${BASE_URL}/elite/v1/wallet-purchase`,
  submitHomework: `${BASE_URL}/elite/v1/submit-homework`,
  submitQuiz: `${BASE_URL}/elite/v1/submit-quiz`,
  videoView: `${BASE_URL}/elite/v1/videoview`,
  aws: `${BASE_URL}/elite/v1/img-file-upload`,
  imageUpload: `${BASE_URL}/elite/v1/img-file-upload`,
  // drive: `${BASE_URL}/elite/v1/drive`,
  drive: `${BASE_URL}/elite/v1/aws`,
  eliteUpload: `${BASE_URL}/elite/v1/elite-upload-to-server`,
  createCoupons: `${BASE_URL}/elite/v1/create-teacher-coupons`,
  generateCodes: `${BASE_URL}/elite/v2/generate-codes`,
  submitAttendance: `${BASE_URL}/elite/v1/submit-attendance`,
  submitFcmInfo: `${BASE_URL}/elite/v1/submit-fcm-info`,
  sendNotification: `${BASE_URL}/elite/v1/send-notification`,
  getNotifications: `${BASE_URL}/elite/v1/get-notifications`,
  createLiveSession: `${BASE_URL}/elite/v1/create-live-session`,
  createSubscription: `${BASE_URL}/elite/v1/create-subscription`,
  updatePortal: `${BASE_URL}/elite/v1/update-portal`,
  createPortal: `${BASE_URL}/elite/v1/create-portal`,
  verifyTutorData: `${BASE_URL}/elite/v1/verify-tutor-data`,
  createOTP: `${BASE_URL}/otp/v1/create`,
  verifyOTP: `${BASE_URL}/otp/v1/verify`,
  createTutor: `${BASE_URL}/elite/v1/create-tutor`,
  checkSubdomain: `${BASE_URL}/elite/v1/check-subdomain`,
  startLiveSession: `${BASE_URL}/elite/v1/start-live-session`,
  endLiveSession: `${BASE_URL}/elite/v1/end-live-session`,
  walletRecharge: `${BASE_URL}/elite/v1/wallet-recharge`,
  createAssistant: `${BASE_URL}/elite/v1/create-assistant`,
  updateAssistant: `${BASE_URL}/elite/v1/update-assistant`,
};
